import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import scopesJson from '@designwithfriends/common/permissions/scopes.json';

/** The shared scope catalogue: id → { area, label, description, ownership }. */
export const SCOPES = scopesJson;

export const FULL_ADMIN_SCOPE = '*';
export const USER_REQUESTS_SCOPE = 'upload-pipeline.user-requests';

/**
 * Whether `granted` satisfies a check for `scope`. Full admin satisfies
 * everything, and for ownership scopes `.all` also satisfies a check for
 * `.mine` (the default). Mirrors catalogue-service's `hasScope`.
 */
export function hasScope(granted, scope, ownership = 'mine') {
    const definition = SCOPES[scope];
    // A typo would otherwise read as "not allowed" and silently hide the feature.
    if (!definition) throw new Error(`Unknown permission scope "${scope}"`);
    if (granted.includes(FULL_ADMIN_SCOPE)) return true;
    if (!definition.ownership) return granted.includes(scope);
    return granted.includes(`${scope}.all`) || (ownership === 'mine' && granted.includes(`${scope}.mine`));
}

export const useCurrentUser = () => useContext(MobXProviderContext).currentUserStore;
